var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_965_511",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.362183 -7.62939e-05H27.4543V27.092H0.362183V-7.62939e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_965_511)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9082 27.092C14.1736 27.092 14.4214 26.9594 14.5686 26.7386C15.1723 25.8331 15.8618 24.8675 16.5916 23.8455C16.8108 23.5385 17.0336 23.2264 17.2589 22.9093C18.2281 21.545 19.2329 20.1002 20.1403 18.6249C21.938 15.7019 23.4328 12.5373 23.4328 9.52449C23.4328 4.27194 19.1608 -7.62939e-05 13.9082 -7.62939e-05C8.65569 -7.62939e-05 4.38367 4.27194 4.38367 9.52449C4.38367 12.5373 5.87844 15.7019 7.67616 18.6249C8.58355 20.1002 9.58838 21.545 10.5576 22.9093C10.7828 23.2264 11.0057 23.5385 11.2249 23.8455C11.9547 24.8675 12.6442 25.8331 13.2478 26.7386C13.395 26.9594 13.6429 27.092 13.9082 27.092ZM9.02832 17.7932C7.25432 14.9089 5.9711 12.0677 5.9711 9.52449C5.9711 5.14866 9.5324 1.58735 13.9082 1.58735C18.2841 1.58735 21.8454 5.14866 21.8454 9.52449C21.8454 12.0677 20.5622 14.9089 18.7882 17.7932C17.9097 19.2216 16.9302 20.6309 15.9648 21.99C15.7457 22.2984 15.5269 22.6048 15.31 22.9085C14.8263 23.5859 14.3525 24.2494 13.9082 24.8893C13.464 24.2494 12.9902 23.5859 12.5064 22.9084C12.2896 22.6048 12.0708 22.2984 11.8517 21.99C10.8862 20.6309 9.90679 19.2216 9.02832 17.7932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14595 9.52452C9.14595 12.151 11.2817 14.2868 13.9082 14.2868C16.5348 14.2868 18.6705 12.151 18.6705 9.52452C18.6705 6.898 16.5348 4.76223 13.9082 4.76223C11.2817 4.76223 9.14595 6.898 9.14595 9.52452ZM13.9082 12.6994C12.1584 12.6994 10.7334 11.2743 10.7334 9.52452C10.7334 7.77471 12.1584 6.34966 13.9082 6.34966C15.658 6.34966 17.0831 7.77471 17.0831 9.52452C17.0831 11.2743 15.658 12.6994 13.9082 12.6994Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconW);
export default __webpack_public_path__ + "static/media/location-icon-w.d62ac3c3ddc4e6cf5729954118a1e3d3.svg";
export { ForwardRef as ReactComponent };